import { useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";

type Props = {
	text: string;
	countText: string;
	selected?: boolean;
	onSelectCallback: () => void;
};
export const CalendarPanelReservationContent = ({ text, countText, selected, onSelectCallback }: Props) => {
	/**
	 * 押下時の処理
	 */
	const handleClick = useCallback(() => {
		onSelectCallback();
	}, [onSelectCallback]);

	return (
		<div
			className={cn(
				"relative flex cursor-pointer flex-wrap items-center justify-between gap-x-2 gap-y-1 text-xs hover:font-semibold",
			)}
			onClick={handleClick}
		>
			{selected && <div className="absolute -bottom-[2px] w-full border border-brand" />}

			<p>{text}</p>
			<p>{countText}</p>
		</div>
	);
};
